import { FC } from "react";

import { Stack } from "@mui/material";

import { useMediaQuery } from "../../../hooks/useMediaQuery";

import { BaseFormV2Step1Layout, BaseFormV2Step1LayoutProps } from "./BaseFormV2Step1Layout";

export type PeerToPeerFormV2IndividualCampaignStep1LayoutProps = Omit<BaseFormV2Step1LayoutProps, "slots"> & {
  slots: {
    banner?: React.ReactNode;
    summary: React.ReactNode;
    hostedBy: React.ReactNode;
    donors: React.ReactNode;
    helpFundraise: React.ReactNode;
    donationAmounts: React.ReactNode;
    generateReceipt: React.ReactNode;
    zeffyBusinessModel: React.ReactNode;
    checkoutFooter: React.ReactNode;
  };
};

export const PeerToPeerFormV2IndividualCampaignStep1Layout: FC<PeerToPeerFormV2IndividualCampaignStep1LayoutProps> = ({
  slots,
  isOneColumn,
  isEmbed,
  ...rest
}) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <BaseFormV2Step1Layout
      {...rest}
      slots={{
        banner: slots.banner,
        info: (
          <Stack alignItems="flex-start" width="100%" gap={2}>
            {slots.summary}
            {!isSmallScreen && !isOneColumn && !isEmbed && slots.donors}
            {!isSmallScreen && !isOneColumn && !isEmbed && slots.hostedBy}
            {!isSmallScreen && !isOneColumn && !isEmbed && slots.helpFundraise}
          </Stack>
        ),
        order: (
          <Stack width="100%" gap={2}>
            {slots.donationAmounts}
            {slots.generateReceipt}
            {slots.zeffyBusinessModel}
            {(isSmallScreen || isOneColumn || isEmbed) && slots.donors}
            {(isSmallScreen || isOneColumn || isEmbed) && slots.hostedBy}
            {(isSmallScreen || isOneColumn || isEmbed) && slots.helpFundraise}
          </Stack>
        ),
        checkoutFooter: slots.checkoutFooter,
      }}
    />
  );
};
